import { displayFeature, RenderFeatureValues } from "@/utils/features/display";

export const renderFeature = (feature?: RenderFeatureValues | null) => {
    const featureValue = displayFeature(feature);

    if (featureValue.toLowerCase() === "true") {
        return (
            <span>
                <i className="las la-check"></i>
            </span>
        );
    }

    if (featureValue.toLowerCase() === "false") {
        return (
            <span>
                <i className="las la-times"></i>
            </span>
        );
    }

    return featureValue;
};
